// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.fe1.stage.monatest.icu/auto-open-api-spec.yaml 1.3.6
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2023-08-09T20:01:36.017052+02:00[Europe/Berlin]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validation the anamnesis part of the admission payload
 * @see #/components/schemas/AdmissionAnamnesis - reference to schema in open-api-spec.yaml
 * @since 2023-08-09T20:01:36.017052+02:00[Europe/Berlin]
 * @version 1.3.6
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface AdmissionAnamnesis {
    /**
     * The type of admission for this patient  * `planned-surgical` - PLANNED_SURGICAL * `emergency-surgical` - EMERGENCY_SURGICAL * `general-medical` - GENERAL_MEDICAL
     *
     */
    type_of_admission: AdmissionAnamnesis.TypeOfAdmissionEnum;
    /**
     * The text part of the anamnesis
     *
     */
    text: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for AdmissionAnamnesis
 */
export namespace AdmissionAnamnesis {
    export type TypeOfAdmissionEnum = 'planned-surgical' | 'emergency-surgical' | 'general-medical';
    export const TypeOfAdmissionEnum = {
        PlannedSurgical: 'planned-surgical' as TypeOfAdmissionEnum,
        EmergencySurgical: 'emergency-surgical' as TypeOfAdmissionEnum,
        GeneralMedical: 'general-medical' as TypeOfAdmissionEnum,
    };

    /**
     * AdmissionAnamnesis Frontend Model with camelCase properties
     * @since 2023-08-09T20:01:36.017052+02:00[Europe/Berlin]
     * @version 1.3.6
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The type of admission for this patient  * `planned-surgical` - PLANNED_SURGICAL * `emergency-surgical` - EMERGENCY_SURGICAL * `general-medical` - GENERAL_MEDICAL
         * @type string (`dataFormat` is missing)
         */
        typeOfAdmission: AdmissionAnamnesis.TypeOfAdmissionEnum;
        /**
         * The text part of the anamnesis
         * @type string (`dataFormat` is missing)
         */
        text: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * AdmissionAnamnesis DTO
     * Transforms AdmissionAnamnesis model from/to API object
     * @since 2023-08-09T20:01:36.017052+02:00[Europe/Berlin]
     * @version 1.3.6
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend AdmissionAnamnesis model */
        static toModel(obj: AdmissionAnamnesis): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend AdmissionAnamnesis model */
        static toApi(obj: Model): AdmissionAnamnesis {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as AdmissionAnamnesis;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
